import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { PostUserFailure, PostUserRequest, PostUserSuccess } from './actions';
import { User } from '@models/swagger';
import { PostUserParams, PostUserService } from './service';

@Injectable()
export class PostUserEffects {
  private readonly actions$ = inject(Actions);
  private readonly postUserService = inject(PostUserService);

  postUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PostUserRequest),
      switchMap(({ body, parameters }: { body: User; parameters?: PostUserParams }) =>
        this.postUserService.postUser(body, parameters).pipe(
          map((data: { userId: string }) => PostUserSuccess({ data })),
          catchError(error => of(PostUserFailure({ error })))
        )
      )
    )
  );

}
